export const columnTypes = {
  todo: 'todo',
  inprogress: 'inprogress',
  done: 'done',
  sub_done: 'subcolumn_done',
  sub_inprogress: 'subcolumn_inprogress'
};
